export const VALIDATION_MESSAGE = 'Please enter a valid date'

export const MONTH_LABELS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const DAY_OF_WEEK_LABELS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export const DAY_OF_WEEK_SHORT_LABELS = ['S', 'M', 'T', 'W', 'Th', 'F', 'S']

export const ENTER_KEYCODE = 13

export const YEAR_CHUNK = 12

export const DEFAULT_MIN_DATE = '0000-01-01'
export const DEFAULT_EXTERNAL_DATE_FORMAT = 'MM/DD/YYYY'
export const INTERNAL_DATE_FORMAT = 'YYYY-MM-DD'
